import React from 'react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_flats-clean-service/artifacts/2b1a8yim_Screenshot_20260123_012606_Drive.jpg";

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="w-full py-4 px-6 bg-white border-b border-gray-100">
        <div className="max-w-4xl mx-auto">
          <a href="/">
            <img 
              src={LOGO_URL} 
              alt="Just Cleaned" 
              className="h-12 w-auto object-contain"
            />
          </a>
        </div>
      </header>

      {/* Content */}
      <main className="px-6 py-12">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl font-semibold text-gray-900 mb-8">Privacy Policy</h1>
          
          <div className="prose prose-gray max-w-none space-y-6 text-gray-700">
            <p className="text-sm text-gray-500">Last updated: January 2025</p>
            
            <section>
              <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">Who We Are</h2>
              <p>Just Cleaned provides communal block cleaning services across North and Greater London. This policy explains how we collect, use, and protect your personal data.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">Data We Collect</h2>
              <p>When you submit an enquiry through our website, we collect:</p>
              <ul className="list-disc pl-6 mt-2 space-y-1">
                <li>Full name</li>
                <li>Company name</li>
                <li>Email address</li>
                <li>Phone number</li>
                <li>Your role</li>
                <li>Block location (postcode or area)</li>
                <li>Number of blocks and cleaning frequency preferences</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">Why We Collect Your Data</h2>
              <p>We use your data solely to:</p>
              <ul className="list-disc pl-6 mt-2 space-y-1">
                <li>Respond to your enquiry</li>
                <li>Arrange site assessments</li>
                <li>Provide quotes for our services</li>
                <li>Communicate about our cleaning services</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">How We Protect Your Data</h2>
              <p>Your data is stored securely and accessed only by authorised personnel. We use industry-standard security measures to protect your information from unauthorised access, alteration, or disclosure.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">Data Sharing</h2>
              <p>We do not sell, rent, or share your personal data with third parties for marketing purposes. Your information is used exclusively for the purposes stated above.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">Your Rights (GDPR)</h2>
              <p>Under the UK General Data Protection Regulation (GDPR), you have the right to:</p>
              <ul className="list-disc pl-6 mt-2 space-y-1">
                <li>Access your personal data</li>
                <li>Request correction of inaccurate data</li>
                <li>Request deletion of your data</li>
                <li>Object to processing of your data</li>
                <li>Request data portability</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">Contact Us</h2>
              <p>For any data-related requests or questions about this policy, please contact us at:</p>
              <p className="mt-2"><strong>Email:</strong> justcleanedltd@gmail.com</p>
            </section>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="px-6 py-8 bg-white border-t border-gray-100 mt-12">
        <div className="max-w-4xl mx-auto text-center text-gray-500 text-sm">
          <p>Just Cleaned • Communal block cleaning</p>
        </div>
      </footer>
    </div>
  );
};

export default PrivacyPolicy;
